import { theme } from "../../theme";
export const attendeesOverview = {
    wrapper: {
      display: "flex",
      justifyContent: "space-between",
    },
    contentWrapper: {
      height: "calc(100vh - 105px)",
      display: "flex",
      flexDirection: "column",
      // width: "74%", the width of the content part if we show the badge preview
      width: "100%",
    },
    badgeWrapper: {
      height: "calc(100vh - 105px)",
      display: "flex",
      flexDirection: "column",
      width: "24%",
    },
    topActions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    topFilters: {
      paddingTop: "20px",
      paddingBottom: "20px",
    },
    userIcon: {
      position: "relative",
      top: "3px",
      marginRight: "7px",
      color: theme.palette.text.primary,
      fontSize: "18px",
    },
    searchForm: {
      display: "flex",
      flexGrow: 1,
      alignItems: "center",
    },
    searchInput: {
      flex: 1,
      border: 0,
      boxShadow: "none",
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      "&.MuiFormControl-root": {
        m: 0,
      },
      "& .MuiInputBase-root": {
        padding: "9px 10px 9px 10px",
        borderTopRightRadius: "0 !important",
        borderBottomRightRadius: "0 !important",
      },
    },
    searchButton: {
      borderTopLeftRadius: 0,
      borderTopRightRadius: "5px",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: "5px",
    },
    listContent: {
      position: "relative",
      width: "100%",
      flexGrow: 1,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      overflow: "auto",
    },
    listContentActions: {
      display: "flex",
      justifyContent: "space-between",
      paddingBottom: "10px",
    },
    selectedFilters: {},
    filterChip: {
      marginBottom: "5px",
      marginRight: "5px",
      float: "left",
    },
    clearIcon: {
      cursor: "pointer",
      marginRight:'10px',
    },
  } as const;